export function useViewPortBottom(mobileOnly?: boolean): Ref<string> {
    const bottomPx = ref<string>('0px');

    const updateBottom = (): void => {
        const vp = window.visualViewport;
        if (!vp) {
            bottomPx.value = '0px';
            return;
        }

        // Distance from bottom of visible viewport to bottom of layout viewport
        const offset =
            document.documentElement.clientHeight - (vp.height + vp.offsetTop);

        // Clamp to 0 so it never goes negative
        bottomPx.value = `${Math.max(0, offset)}px`;
    };

    onMounted(() => {
        updateBottom();
        if (mobileOnly && !useSize().isMobile.value) {
            return;
        }
        window.addEventListener('resize', updateBottom, { passive: true });
        window.addEventListener('scroll', updateBottom, { passive: true });

        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', updateBottom);
            window.visualViewport.addEventListener('scroll', updateBottom);
        }
    });

    onBeforeUnmount(() => {
        window.removeEventListener('resize', updateBottom);
        window.removeEventListener('scroll', updateBottom);

        if (window.visualViewport) {
            window.visualViewport.removeEventListener('resize', updateBottom);
            window.visualViewport.removeEventListener('scroll', updateBottom);
        }
    });

    return bottomPx;
}
